// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration - Provided by the user
const firebaseConfig = {
  "projectId": "logistica-sabores-fpwl2",
  "appId": "1:848289732568:web:ec28844cf732282c09c4ad",
  "storageBucket": "logistica-sabores-fpwl2.firebasestorage.app",
  "apiKey": "AIzaSyCsraBAA4pe4Sf_0T8Dylcpd8X9Vw_-ISU",
  "authDomain": "logistica-sabores-fpwl2.firebaseapp.com",
  "messagingSenderId": "848289732568"
};


// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export { app, auth, db, storage, getFirestore };
